import React from 'react';
import { formatMoney } from '../../util/currency';
import { FormattedMessage, injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import config from '../../config';
import moment from 'moment';
import css from './UpdatedInvoice.module.css';
import { InlineTextButton } from '../Button/Button';
const { types } = require('sharetribe-flex-sdk');
const { Money } = types;
const myDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function UpdatedInvoice(props) {
  const { listing, intl, tab, history, setShowInvoiceModal, userNativeLang } = props;
  const workerCount = listing?.attributes?.publicData?.workerYouNeed;

  const listingPrice = new Money(
    listing?.attributes?.publicData?.clientPrice?.amount || 0,
    listing?.attributes?.publicData?.clientPrice?.currency
  );
  // console.log(454, workerCount, listingPrice);

  const priceData = (price, intl) => {
    if (price && price.currency === config.currency) {
      const formattedPrice = formatMoney(intl, price);
      return { formattedPrice, priceTitle: formattedPrice };
    } else if (price) {
      return {
        formattedPrice: intl.formatMessage(
          { id: 'ListingCard.unsupportedPrice' },
          { currency: price.currency }
        ),
        priceTitle: intl.formatMessage(
          { id: 'ListingCard.unsupportedPriceTitle' },
          { currency: price.currency }
        ),
      };
    }
    return {};
  };
  const { formattedPrice, priceTitle } = priceData(listingPrice, intl);

  const oneTimeScheduleList = listing?.attributes?.publicData?.oneTimeScheduleList ?? [];
  const recurringScheduleList = listing?.attributes?.publicData?.recurringScheduleList ?? [];
  const { scheduleType } = listing && listing?.attributes?.publicData;

  // working hour for one-time schedule calculation

  const totalWorkingHourInMin = o => {
    const startTimeHour = parseInt(o?.startTime?.hours?.value, 10);
    const startTimeMinute = parseInt(o?.startTime?.min?.value, 10);

    // End time
    const endTimeHour = parseInt(o?.endTime?.hours?.value);
    const endTimeMinute = parseInt(o?.endTime?.min?.value);

    const sDate = moment(o?.startDate?.date).set({
      hour: startTimeHour,
      minute: startTimeMinute,
    });
    let eDate = moment(o?.startDate?.date).set({
      hour: endTimeHour,
      minute: endTimeMinute,
    });

    if (startTimeHour > endTimeHour) {
      eDate.add(1, 'day');
    }

    const unpaidBreak = parseInt(o?.unpaidBreak?.value);

    const durationInMinutes =
      unpaidBreak < 0 ? eDate.diff(sDate, 'minutes') : eDate.diff(sDate, 'minutes') - unpaidBreak;

    return durationInMinutes;
  };
  const oneTimeWorkInMin =
    scheduleType === 'oneTime' &&
    oneTimeScheduleList &&
    oneTimeScheduleList?.[0].startDate?.date !== null &&
    oneTimeScheduleList.map(totalWorkingHourInMin);

  const totalOneTimeWorkDurationInMin =
    oneTimeWorkInMin && oneTimeWorkInMin.reduce((a, b) => a + b, 0);

  // working hour for recurring schedule calculation

  const countTotalDaysInDateRange = (startDate, endDate, weekdays) => {
    const oneDay = 24 * 60 * 60 * 1000; // Number of milliseconds in a day
    let currentDate = new Date(startDate);
    const targetDate = new Date(endDate);

    const weekdayCounts = {};
    weekdays.forEach(weekday => {
      weekdayCounts[weekday] = 0;
    });

    // Iterate through the dates in the range
    while (currentDate <= targetDate) {
      const dayOfWeek = currentDate.getDay();
      const someday = myDays[dayOfWeek];
      // console.log(369, someday, dayOfWeek, weekdays);

      // Check if the day is in the provided weekdays array
      if (weekdays.includes(someday)) {
        weekdayCounts[someday]++;
      }

      currentDate.setTime(currentDate.getTime() + oneDay); // Move to the next day
    }
    const totalDays = Object.values(weekdayCounts).reduce((a, b) => a + b, 0);
    // console.log(123, weekdayCounts, totalDays);

    return totalDays;
  };

  const recDaysArray = [];
  recurringScheduleList.map(o => {
    const recurringIntervalType = o?.recurringInterval?.value;

    if (recurringIntervalType === 'Daily') {
      let date1 = moment(o?.startDate?.date);
      let date2 = moment(o?.endDate?.date);
      let totalDays = date2.diff(date1, 'days') + 1;
      recDaysArray.push(totalDays);
    } else {
      const totalDays = countTotalDaysInDateRange(
        moment(o?.startDate?.date).format('YYYY-MM-DD'),
        moment(o?.endDate?.date).format('YYYY-MM-DD'),
        o.recurringDays && typeof o.recurringDays === 'string' ? o.recurringDays.split(',') : []
      );

      recDaysArray.push(totalDays);
    }
  });
  // console.log(666, recDaysArray);
  const ListOfRecurringWorkInMin =
    scheduleType === 'recurring' &&
    recurringScheduleList &&
    recurringScheduleList?.[0].recurringInterval !== '' &&
    recurringScheduleList.map(totalWorkingHourInMin);

  const recurringWorkDurationInMin =
    ListOfRecurringWorkInMin &&
    ListOfRecurringWorkInMin.map((m, indx) => m * recDaysArray[indx]).reduce((a, b) => a + b, 0);

  const totalWorkingDurationInmin =
    scheduleType === 'oneTime' ? totalOneTimeWorkDurationInMin : recurringWorkDurationInMin;

  const convertHourPriceToMinutePrice = priceInCentsPerHour => {
    const minutesPerHour = 60;
    const priceInCentsPerMinute = priceInCentsPerHour / minutesPerHour;
    return priceInCentsPerMinute;
  };

  const priceInCentsPerHour = listingPrice?.amount;
  const priceInCentsPerMinute = convertHourPriceToMinutePrice(priceInCentsPerHour);
  const workerPrice = listing?.attributes?.price?.amount || 0;
  const workerPricePerMinute = Math.max(
    0,
    priceInCentsPerMinute - convertHourPriceToMinutePrice(workerPrice)
  );

  const totalWages = new Money(
    totalWorkingDurationInmin * priceInCentsPerMinute * workerCount || 0,
    config.currency
  );

  const djobComission = new Money(
    totalWorkingDurationInmin * workerPricePerMinute * workerCount || 0,
    config.currency
  );

  const wagesWithoutTaxes = new Money(totalWages.amount || 0, config.currency);
  const wagesWithoutTaxesAsMoney = priceData(wagesWithoutTaxes || 0, intl)?.formattedPrice;

  //wages with gst
  const gstTax = new Money(
    Math.round(((djobComission.amount || 0) * config.gstPercent) / 100),
    config.currency
  );
  const gstTaxAsMoney = priceData(gstTax || 0, intl)?.formattedPrice;

  //wages with qst
  const qstTax = new Money(
    Math.round(((djobComission.amount || 0) * config.qstPercent) / 100),
    config.currency
  );
  const qstTaxAsMoney = priceData(qstTax || 0, intl)?.formattedPrice;

  //total amount
  const totalAmount = new Money(
    (wagesWithoutTaxes.amount || 0) + (gstTax.amount || 0) + (qstTax.amount || 0),
    config.currency
  );
  const totalAmountAsMoney = priceData(totalAmount || 0, intl)?.formattedPrice;

  // console.log(
  //   696,

  //   totalAmountAsMoney
  // );
  return (
    <div className={css.invoiceContainer}>
      <div className={css.detailsContainerDesktop}>
        <div>
          <div className={css.workerCountDiv}>
            <span>
              <FormattedMessage id="BusinessCheckoutPage.proposedWorkers" />
            </span>
            <span>{workerCount}</span>
          </div>
          <div className={css.workerCountDiv}>
            <span>
              <FormattedMessage id="BookingBreakdown.pricePerQuantity" />
            </span>
            <span>{formattedPrice}</span>
          </div>

          {scheduleType === 'oneTime' &&
          oneTimeScheduleList &&
          oneTimeScheduleList?.[0].startDate?.date !== null
            ? oneTimeScheduleList.map((o, indx) => {
                // Start time
                // console.log(545, o);
                const startTimeHour = parseInt(o?.startTime?.hours?.value, 10);
                const startTimeMinute = parseInt(o?.startTime?.min?.value, 10);

                // End time
                const endTimeHour = parseInt(o?.endTime?.hours?.value);
                const endTimeMinute = parseInt(o?.endTime?.min?.value);

                // Convert hours to minutes
                const startTimeInMinutes =
                  startTimeHour !== 0 ? startTimeHour * 60 + startTimeMinute : startTimeMinute;
                const endTimeInMinutes =
                  endTimeHour !== 0 ? endTimeHour * 60 + endTimeMinute : endTimeMinute;

                // Calculate the duration in minutes
                let durationInMinutes = endTimeInMinutes - startTimeInMinutes;

                const unpaidBreak = o?.unpaidBreak;

                let totalDurationInMins =
                  typeof unpaidBreak === 'string'
                    ? durationInMinutes
                    : durationInMinutes - parseInt(unpaidBreak?.value);

                if (totalDurationInMins < 0) {
                  totalDurationInMins += 24 * 60;
                }

                const durationHours = Math.floor(totalDurationInMins / 60);
                const durationMinutes = totalDurationInMins % 60;

                return (
                  <div className={css.scheduleDiv} key={indx}>
                    <div className={css.workerCountDiv}>
                      <span>
                        <FormattedMessage id="BusinessCheckoutPage.workPerDay" />
                      </span>
                      <span>{` ${durationHours} hours ${durationMinutes} minutes`} - &nbsp;</span>
                    </div>
                    {/* {typeof unpaidBreak === 'string' ? null : (
                      <div className={css.workerCountDiv}>
                        <span>
                          <FormattedMessage id="BusinessCheckoutPage.unpaidBreak" />
                        </span>
                        <span>{unpaidBreak?.label[userNativeLang]} - </span>
                      </div>
                    )} */}
                    {parseInt(unpaidBreak.value) <= 0 ? null : (
                      <div className={css.workerCountDiv}>
                        <span>
                          <FormattedMessage id="BusinessCheckoutPage.unpaidBreak" />
                        </span>
                        <span>{unpaidBreak?.label?.[userNativeLang]} &nbsp;-&nbsp;</span>
                      </div>
                    )}

                    <div className={css.workerCountDiv}>
                      <span>
                        <FormattedMessage id="BusinessCheckoutPage.day" />
                      </span>
                      <span>{moment(o?.startDate?.date).format('Do MMMM, YYYY')}</span>
                    </div>
                  </div>
                );
              })
            : null}
          {/* {console.log(4, recurringScheduleList?.[0].recurringInterval !== '')} */}
          {scheduleType === 'recurring' &&
          recurringScheduleList &&
          recurringScheduleList?.[0].recurringInterval !== ''
            ? recurringScheduleList.map((o, indx) => {
                // Start time
                const startTimeHour = parseInt(o?.startTime?.hours?.value, 10);
                const startTimeMinute = parseInt(o?.startTime?.min?.value, 10);

                // End time
                const endTimeHour = parseInt(o?.endTime?.hours?.value);
                const endTimeMinute = parseInt(o?.endTime?.min?.value);

                // Convert hours to minutes
                const startTimeInMinutes =
                  startTimeHour !== 0 ? startTimeHour * 60 + startTimeMinute : startTimeMinute;
                const endTimeInMinutes =
                  endTimeHour !== 0 ? endTimeHour * 60 + endTimeMinute : endTimeMinute;

                // Calculate the duration in minutes
                let durationInMinutes = endTimeInMinutes - startTimeInMinutes;

                //subtract the unpaid break duration

                const unpaidBreak = o?.unpaidBreak;

                let totalDurationInMins =
                  typeof unpaidBreak === 'string'
                    ? durationInMinutes
                    : durationInMinutes - parseInt(unpaidBreak?.value);

                if (totalDurationInMins < 0) {
                  totalDurationInMins += 24 * 60;
                }

                const durationHours = Math.floor(totalDurationInMins / 60);
                const durationMinutes = totalDurationInMins % 60;

                //start date
                const recStartDate = moment(o?.startDate?.date).format('Do-MMMM, YYYY');

                //end date
                const recEndDate = moment(o?.endDate?.date).format('Do MMMM, YYYY');

                //recurring interval

                const recurringIntervalType = o?.recurringInterval?.value;
                const recurringDays =
                  o.recurringDays && typeof o.recurringDays === 'string'
                    ? o.recurringDays.split(',')
                    : [];

                const getRecurringDays = recurringDaysList => {
                  // console.log(1, recurringDaysList);
                  let result = '';
                  if (recurringDaysList.length === 1) {
                    result = recurringDaysList[0];
                  } else if (recurringDaysList.length === 2) {
                    result = recurringDaysList.join(' and ');
                  } else {
                    const lastDay = recurringDaysList.pop();
                    result = recurringDaysList.join(', ') + ' and ' + lastDay;
                  }
                  return result;
                };
                const recurringDayValue =
                  recurringIntervalType === 'Daily' ? 'Daily' : getRecurringDays(recurringDays);

                // console.log(52, recurringIntervalType, o?.recurringDays, recurringDayValue);
                return (
                  <div className={css.recScheduleDiv} key={indx}>
                    <div className={css.scheduleDiv}>
                      <div className={css.workerCountDiv}>
                        <span>
                          {' '}
                          <FormattedMessage id="BusinessCheckoutPage.workPerDay" />
                        </span>
                        <span>
                          {` ${durationHours} hours`}{' '}
                          {durationMinutes > 0 ? <> {`${durationMinutes} minutes`}</> : null} -{' '}
                        </span>
                      </div>
                      {parseInt(unpaidBreak.value) <= 0 ? null : (
                        <div className={css.workerCountDiv}>
                          <span>
                            <FormattedMessage id="BusinessCheckoutPage.unpaidBreak" />
                          </span>
                          <span>{unpaidBreak?.label?.[userNativeLang]} &nbsp;-&nbsp;</span>
                        </div>
                      )}
                    </div>
                    <div className={css.scheduleDiv}>
                      <div className={css.workerCountDiv}>
                        <span>
                          <FormattedMessage id="SearchPage.recurringDays" />
                        </span>
                        <span>{recurringDayValue} - </span>
                      </div>
                      <div className={css.workerCountDiv}>
                        <span className={css.labelWithLeftMargin}>
                          <FormattedMessage id="BusinessCheckoutPage.days" />
                        </span>
                        <span>{recStartDate} </span>
                        <FormattedMessage id="SearchPage.to" />
                        <span>{recEndDate}</span>
                      </div>
                    </div>
                  </div>
                );
              })
            : null}
        </div>
        <div>
          <div className={css.peiceRow}>
            <span>
              {/* <FormattedMessage id="BusinessCheckoutPage.TotalBeforeTaxes" /> */}
              <FormattedMessage id="BusinessCheckoutPage.totalWages" />
            </span>
            <span>{wagesWithoutTaxesAsMoney}</span>
          </div>
          <div className={css.taxDiv}>
            <span>
              <FormattedMessage id="BusinessCheckoutPage.salesTaxes" />
            </span>
            <div className={css.taxAmount}>
              <div className={css.peiceRow}>
                <span>
                  {' '}
                  <FormattedMessage id="BusinessCheckoutPage.gstTaxes" />
                </span>

                <span>{gstTaxAsMoney}</span>
              </div>
              <div className={css.peiceRow}>
                <span>
                  <FormattedMessage id="BusinessCheckoutPage.qstTaxes" />
                </span>
                <span>{qstTaxAsMoney}</span>
              </div>
            </div>
          </div>
          <span className={css.hDivider} />
          <div className={css.peiceRow}>
            <span>
              <FormattedMessage id="BusinessCheckoutPage.TotalAmount" />
            </span>

            <span>{totalAmountAsMoney}</span>
          </div>
        </div>
      </div>

      {/* <div className={css.ButtonContainer}>
        <InlineTextButton
          type="button"
          className={css.cancelBtn}
          onClick={() => {
            if (tab === 'description' || tab === 'availability') {
              history.push(
                createResourceLocatorString('EditListingPage', routeConfiguration(), {
                  id: listing?.id?.uuid,
                  slug: createSlug(listing?.attributes?.title),
                  type: 'edit',
                  tab: 'pricing',
                })
              );
            } else {
              setShowInvoiceModal(false);
            }
          }}
        >
          OKAY
    
        </InlineTextButton>
      </div> */}
    </div>
  );
}

export default compose(
  withRouter,
  injectIntl
)(UpdatedInvoice);

// export default UpdatedInvoice;
